import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../helpers/AuthContext"; // Importez useAuth

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth(); // Utilisez useAuth pour obtenir l'état d'authentification

  if (!isAuthenticated) {
    // Rediriger vers la page de connexion si non authentifié
    return <Navigate to="/admin/buzz/app" replace />;
  }

  return children;
};

export default ProtectedRoute;
